import { jsonp } from '@ifeng-fe/ui_base';

const getUid = () => {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;

        return v.toString(16);
    });
};

export const getSearchInfo = async search => {
    const randomNum = getUid();

    return await jsonp(`https://shankapi.ifeng.com/feedflow/area/employee/${search}/callback_${randomNum}`, {
        jsonpCallback: `callback_${randomNum}`,
        cache: false,
    });
};
